import React from "react";
import "./ErrorSpan.scss";

interface ErrorSpanProps {
  message: string;
}

export function ErrorSpan({ message }: ErrorSpanProps) {
  return <span>{message}</span>;
}
